import { Component, HostListener, OnDestroy, OnInit } from '@angular/core'
import { FormBuilder } from '@angular/forms'
import { RestServices } from '../../../../services/rest.services'
import { AuthService } from '../../../../services/auth.services'
import { SharedServices } from '../../../../services/shared.services'
import { ModalService } from '../../../../services/modal.service'
import { notification } from 'onsenui'
import { Subject } from 'rxjs'

@Component({
    selector: 'app-modal-seting-clinic-edit',
    templateUrl: './modal-clinic-edit.component.html',
    styleUrls: ['../../../../stagingcss/root-ui-view.component.css', '../../../../stagingcss/main-body.component.css', '../../../../stagingcss/main-view.component.css', '../../../../stagingcss/lui-select.component.css'],
})
export class ModalClinicEditComponent implements OnInit, OnDestroy {
// ************************** TASK CLINIC
    hiddenModalClinic = 'hidden'
    hiddenModalNewClinic = 'hidden'
    getnameClinicId
    nameClinic
    getnameClinic
    langDefault = localStorage.getItem('lang') === 'false' ? 'false' : 'true'
    en = {}
    showEN = true
    modalChangeObserver$ = new Subject<boolean>()

    constructor(private _sharedService: SharedServices, private authData: AuthService, private restApi: RestServices, private formBuider: FormBuilder, private modalService: ModalService) {
        modalService.changeEmitted$.takeUntil(this.modalChangeObserver$).subscribe(success => {
            // task clinic
            if (success[1] === 'activeClinicEdit') {
                this.hiddenModalClinic = 'active'
                this.getClinicId(success[2])
            }
            if (success === 'activeNewClinic') {
                this.hiddenModalNewClinic = 'active'
            }
        })
    }

    ngOnInit() {
    }

    ngOnDestroy(): void {
        if(this.modalChangeObserver$){
            this.modalChangeObserver$.next(true)
            this.modalChangeObserver$.unsubscribe()
        }
    }

    changeLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }

    @HostListener('document:keydown', ['$event']) handleKeyboardEvent(event: KeyboardEvent) {
        let keyPressed = event.keyCode
        if (keyPressed === 27) {
            event.preventDefault()
            if (this.nameClinic != undefined) {
                this.changeLanguage()
                notification.confirm({
                    message: this.en['alert-content-discard'],
                    title: '<b>' + this.en['alert-discard'] + '</b>',
                    cancelable: true,
                    buttonLabels: [this.en['alert-cancel'], 'OK'],
                    callback: i => {
                        if (i === 1) {
                            this.hidenModal()
                        }
                    },
                })
            } else {
                this.hidenModal()
            }
        }
    }

    // get list linic id
    getClinicId(success) {
        const resourceUrl = 'resource'
        const map = {}
        map[success] = true
        const resourceData = {
            actions: [], status: {
                clinic: {
                    map, paths: {
                        '{}': true,
                    },
                }, setting: {
                    map: {
                        common: true,
                    }, paths: {
                        '{}': true,
                    },
                }, staff: {
                    paths: {
                        '{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {


            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(reponsive => {
                this.getnameClinicId = reponsive['response']['clinic']['map'][success]['_id']
                this.getnameClinic = reponsive['response']['clinic']['map'][success]['name']
            })
        })
    }

    // ***************************************************** CLINIC SETTING ***************************************************************//
    // new clinic
    createClinic() {
        const resourceData = {
            actions: [{
                type: 'create', collection: 'clinic', value: {
                    name: this.nameClinic,
                },
            }], status: {
                clinic: {
                    paths: {
                        '{}': true,
                    },
                }, setting: {
                    map: {
                        common: true, alignerMail: true, movieMail: true, option: true, testMail: true,
                    }, paths: {
                        '{}': true,
                    },
                }, staff: {
                    paths: {
                        '{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {


            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                this.hiddenModalNewClinic = 'hidden'
                this._sharedService.emitChangeParent(success['response']['clinic']['paths']['{}'])
                this.getnameClinic = null
                this.nameClinic = undefined
            })
        })
    }

    // update clinic
    updateClinic(idClinic) {
        const resourceData = {
            actions: [{
                type: 'update', id: idClinic, collection: 'clinic', value: {
                    name: this.nameClinic,
                },
            }], status: {
                clinic: {
                    paths: {
                        '{}': true,
                    },
                }, setting: {
                    map: {
                        common: true, alignerMail: true, movieMail: true, option: true, testMail: true,
                    }, paths: {
                        '{}': true,
                    },
                }, staff: {
                    paths: {
                        '{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {


            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                this.hiddenModalClinic = 'hidden'
                this._sharedService.emitChangeParent(success['response']['clinic']['paths']['{}'])
                this.getnameClinic = null
                this.nameClinic = undefined
            })
        })
    }

    // remove clinic
    removeClinic(idClinic) {
        const resourceData = {
            actions: [{
                collection: 'clinic', id: idClinic, type: 'remove',
            }], status: {
                clinic: {
                    paths: {
                        '{}': true,
                    },
                }, setting: {
                    map: {
                        common: true, alignerMail: true, movieMail: true, option: true, testMail: true,
                    }, paths: {
                        '{}': true,
                    },
                }, staff: {
                    paths: {
                        '{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {


            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(success => {
                this.hiddenModalClinic = 'hidden'
                this._sharedService.emitChangeParent(success['response']['clinic']['paths']['{}'])
            })
        })
    }

    hidenModal() {
        this.getnameClinic = null
        this.nameClinic = undefined
        this.hiddenModalClinic = 'hidden'
        this.hiddenModalNewClinic = 'hidden'
    }

    alertLanguageClinic() {
        this.langDefault = localStorage.getItem('lang') === 'false' ? 'false' : 'true'
    }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/setting/clinic/modal-clinic-edit.component.ts